import React from 'react';
import { Card, CardContent, CardDescription, CardHeader, CardTitle } from '@/components/ui/card';
import { Table, TableBody, TableCell, TableHead, TableHeader, TableRow } from '@/components/ui/table';
import { Badge } from '@/components/ui/badge';
import type { PayrollData } from './PayrollTypes';

interface PayrollDetailsTableProps {
  payrollData: PayrollData[];
  children?: React.ReactNode;
}

export const PayrollDetailsTable: React.FC<PayrollDetailsTableProps> = ({ 
  payrollData, 
  children 
}) => {
  return (
    <Card>
      <CardHeader>
        <CardTitle>Payroll Details</CardTitle>
        <CardDescription>
          Review employee hours and calculated pay before processing
        </CardDescription>
      </CardHeader>
      <CardContent>
        <Table>
          <TableHeader>
            <TableRow>
              <TableHead>Employee</TableHead>
              <TableHead className="text-right">Total Hours</TableHead>
              <TableHead className="text-right">Regular Hours</TableHead>
              <TableHead className="text-right">Overtime Hours</TableHead>
              <TableHead className="text-right">Hourly Rate</TableHead>
              <TableHead className="text-right">Gross Pay</TableHead>
              <TableHead className="text-right">Net Pay</TableHead>
            </TableRow>
          </TableHeader>
          <TableBody>
            {payrollData.map((employee) => (
              <TableRow key={employee.employee_id}>
                <TableCell className="font-medium">{employee.employee_name}</TableCell>
                <TableCell className="text-right">
                  <Badge variant="outline">{employee.total_hours.toFixed(1)}h</Badge>
                </TableCell>
                <TableCell className="text-right">{employee.regular_hours.toFixed(1)}h</TableCell>
                <TableCell className="text-right">
                  {employee.overtime_hours > 0 ? (
                    <Badge variant="secondary">{employee.overtime_hours.toFixed(1)}h</Badge>
                  ) : (
                    <span className="text-muted-foreground">0h</span>
                  )}
                </TableCell>
                <TableCell className="text-right">${employee.hourly_rate.toFixed(2)}</TableCell>
                <TableCell className="text-right font-medium">
                  ${employee.gross_pay.toFixed(2)}
                </TableCell>
                <TableCell className="text-right font-bold text-green-600">
                  ${employee.net_pay.toFixed(2)}
                </TableCell>
              </TableRow>
            ))}
          </TableBody>
        </Table>
        
        {children && (
          <div className="mt-6">
            {children}
          </div>
        )}
      </CardContent>
    </Card>
  );
};